import AppLayout from "../components/layout/AppLayout";
import RakeTableComponent from "../components/rake/RakeTableComponent";

export default function Rake() {
  return (
    <AppLayout>
      <RakeTableComponent />
    </AppLayout>
  );
}
